var map = {
	"./photo_0.webp": 3147,
	"./photo_1.webp": 328,
	"./photo_2.webp": 4725,
	"./photo_3.webp": 3626,
	"./photo_4.webp": 391,
	"./photo_5.webp": 8532
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7372;